<template>
  <d-row>
    <d-col cols="12" lg="9">
      <d-card class="card-small mb-4">
        <d-card-header class="border-bottom">
          <h6 class="m-0">Walls</h6>
        </d-card-header>
        <d-list-group flush>
          <d-list-group-item class="p-3">
            <d-row>
              <d-col>
                <puzzle-walls-form ref="puzzleWallsForm" />
              </d-col>
            </d-row>
          </d-list-group-item>
        </d-list-group>
      </d-card>
    </d-col>
    <d-col cols="12" lg="3">
      <sidebar-actions
        :model.sync="puzzleWalls"
        @save="save"
        @generate="generate"
      />
    </d-col>
  </d-row>
</template>

<script>
import { cloneDeep } from '_utils';
import Events from '_utils/events';
import PuzzleWallsForm from './PuzzleWallsForm.vue';
import SidebarActions from './SidebarActions.vue';
import { _LOAD_PUZZLE_WALLS_MODEL_, MODEL } from './PuzzleWallsModel';


export default {
  name: 'puzzle-walls-page',
  components: {
    PuzzleWallsForm,
    SidebarActions,
  },
  computed: {
    puzzleWalls() {
      const { puzzleWalls } = this.$store.state.walls;
      if (puzzleWalls) {
        Events.$emit(_LOAD_PUZZLE_WALLS_MODEL_, puzzleWalls);
        return puzzleWalls;
      }
      return cloneDeep(MODEL);
    },
  },
  methods: {
    generate() {
      this.$refs.puzzleWallsForm.generate();
    },
    save() {
      this.$refs.puzzleWallsForm.save();
    },
  },
};
</script>
